import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@heroui/react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';

import { logout } from './patient-app-common/slices/authSlice';

const IDLE_TIMEOUT = 10 * 60 * 1000; // 10 minutes
const WARNING_TIMEOUT = 30 * 1000; // 30 seconds

export default function IdleTimer() {
  const dispatch = useDispatch();
  const { patientId } = useSelector(({ auth }) => auth);
  const { t } = useTranslation('login');

  const warningTimerRef = useRef(null);
  const [warningModal, toggleWarningModal] = useState(false);
  const [logoutModal, toggleLogoutModal] = useState(false);

  useEffect(() => {
    if (!patientId || !warningModal) return;

    const startWarningTimer = () => {
      warningTimerRef.current = setTimeout(() => {
        dispatch(logout());
        toggleWarningModal(false);
        toggleLogoutModal(true);
      }, WARNING_TIMEOUT);
    };

    startWarningTimer();
  }, [warningModal]);

  const handleOnIdle = () => {
    if (!patientId || window.Cypress) return;
    toggleWarningModal(true);
  };

  useIdleTimer({
    timeout: IDLE_TIMEOUT,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  const resetWarning = () => {
    clearTimeout(warningTimerRef.current);
    toggleWarningModal(false);
  };

  return (
    <>
      <Modal
        isOpen={warningModal}
        onClose={resetWarning}
        scrollBehavior="inside"
        size="md"
      >
        <ModalContent>
          <ModalHeader>
            <p className="font-bold pb-2">{t('idletimer.warning_title')}</p>
          </ModalHeader>
          <ModalFooter>
            <Button onPress={resetWarning}>{t('common.action.yes')}</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={logoutModal}
        onClose={() => toggleLogoutModal(false)}
        scrollBehavior="inside"
        size="md"
      >
        <ModalContent>
          <ModalHeader>
            <p className="font-bold pb-2">{t('idletimer.logout_title')}</p>
          </ModalHeader>
          <ModalBody>
            <p>{t('idletimer.logout_text')}</p>
          </ModalBody>
          <ModalFooter>
            <Button onPress={() => toggleLogoutModal(false)}>
              {t('common.action.close')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
